<script lang="ts" setup>
</script>

<template>
  <svg
    width="59"
    height="54"
    viewBox="0 0 59 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.2771 19.6336V32.2309L44.8355 27.1919M37.2771 12.073V7.03409M52.3888 12.0743L57.4278 17.1132M22.1596 12.0743L17.1207 17.1132M54.9114 14.5933L51.5353 17.9694M19.6363 14.5933L23.0124 17.9694M21.5545 44.8269C25.2354 49.4375 30.9042 52.3853 37.2759 52.3853C38.5356 52.3853 39.7702 52.2593 40.9543 52.0578M37.2744 12.0743C28.8115 12.0743 21.5782 17.2896 18.58 24.6716H9.56035M37.2906 12.0743C48.4342 12.0743 57.4664 21.1066 57.4664 32.2502C57.4664 43.3937 48.4342 52.426 37.2906 52.426M17.2704 29.7107C17.1671 30.5421 17.1168 31.3735 17.1168 32.2301H2M7.04024 39.7882H18.5794C18.2518 38.982 17.9747 38.1254 17.7479 37.2688M42.3147 1.99609H32.2369V7.03501H42.3147V1.99609Z"
      stroke="#5061FA"
      stroke-width="2.49596"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style lang="scss" scoped>
</style>
